/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common billing services/utilities.
 */
'use strict';

angular
  .module('services.billing', [])
  /**
   * A factory with common billing utilities.
   */
  .factory('billingUtils', function (httpBilling, $q, $cookies) {
    return {
      /**
       * Payment info object.
       */
      paymentInfo: {},

      paymentRequest: null,

      taxAddressValidationResult: {
        valid: false,
        message: null
      },

      /**
       * Getter method for the paymentInfo object. It will only get the
       * billingInfo object from the server when it has not previously been
       * retrieved.
       *
       * @param {boolean} refresh - If true the call to the server will be made regardless.
       * @returns {Promise} A promise that resolved into the billingInfo object.
       */
      getPaymentInfo: function (refresh) {
        var self = this;

        // If paymentInfo is not empty and a refresh isn't requested
        if (!_.isEmpty(self.paymentInfo) && !refresh) {
          return $q.when(self.paymentInfo);
        }

        // If paymentInfo has never been populated and a request
        // has not already been made to retrieve it then make the http
        // call to populate it.
        if (!self.paymentRequest) {
          self.paymentRequest = $q.defer();
          httpBilling.getBillingInfo().then(function (info) {
            self.paymentInfo = info;
            self.paymentRequest.resolve(info);

            // If we get back a valid result for this call we know that there was not an
            // invalid refresh token so reset the cookie.
            if (!info.code) {
              $cookies.invalidRefreshTokenRetry = undefined;
            }
          });
          self.paymentRequest.promise.finally(() => {
            self.paymentRequest = null;
          });
        }

        return self.paymentRequest.promise;
      },

      /**
       * Determine if the currently in trial mode.
       *
       * @returns {boolean} - True if in trial mode.
       */
      inTrial: function () {
        return this.paymentInfo.status === 'TRIAL';
      },

      /**
       * Determine if the org has an expired license (the org is expired).
       *
       * @returns {boolean} - True if expired.
       */
      isExpired: function () {
        var self = this;
        return self.paymentInfo.status !== 'TRIAL' && moment().isAfter(moment(self.paymentInfo.expires));
      },

      isAccessStopped: function () {
        if (_.isBoolean(this.paymentInfo.accessStopped)) {
          return this.paymentInfo.accessStopped;
        }
        return this.isExpired();
      },

      /**
       * Determine if the currently in renewal period of
       * 30 days until subscription ends.
       *
       * @returns {boolean} - True if in renewal period.
       */
      inRenewalPeriod: function () {
        var self = this,
          ends,
          daysLeft;

        if (self.paymentInfo.status) {
          ends = moment(self.paymentInfo.expires);
          daysLeft = ends.diff(moment(new Date()), 'days');
          return daysLeft <= 30 && self.paymentInfo.status !== 'TRIAL';
        } else {
          return false;
        }
      },

      /**
       * Determine if specified address is valid
       * @param {object} taxAddress
       * @returns {Promise} A promise to resolve into address validation info
       */
      validateTaxAddress: function (taxAddress) {
        var deferred = $q.defer(),
          self = this;

        httpBilling.validateTaxAddress(taxAddress).then(function (info) {
          self.taxAddressValidationResult = info;
          deferred.resolve(info);
        });

        return deferred.promise;
      },

      /*eslint-disable */
      /**
       * Prepare address for frontend form
       * @param line1
       * @param line2
       * @param city
       * @param state
       * @param postal_code
       * @param country
       * @returns {{zipCode: *, country: *, city: *, state: *, line2: *, line1: *}}
       */
      prepareAddressForFrontend: ({ line1, line2, city, state, postal_code, country }) => {
        return { line1, line2, city, state, zipCode: postal_code, country };
      },
      /*eslint-enable */

      /**
       * Check customer specified the address and transform to the frontend format
       * @returns {{}|{zipCode: *, country: *, city: *, state: *, line2: *, line1: *}}
       */
      getCurrentAddress: function () {
        if (
          this.paymentInfo.paymentInfo &&
          this.paymentInfo.paymentInfo.stripe &&
          this.paymentInfo.paymentInfo.stripe.address
        ) {
          // TODO: Get rid of this as soon as customer info starts to contain TaxAddress object
          return this.prepareAddressForFrontend(this.paymentInfo.paymentInfo.stripe.address);
        }

        return {};
      }
    };
  });
